let selectCall = [
  ['中国', '+86', 'China'],
  ['美国', '+1', 'USA'],
  ['日本', '+81', 'Japan'],
  ['中国香港', '+852', 'Hong Kong China'],
  ['中国台湾', '+886', 'Taiwan of China'],
  ['马来西亚', '+60', 'Malaysia'],
  ['澳大利亚', '+61', 'Australia'],
  ['加拿大', '+1', 'Canada'],
  ['英国', '+44', 'UK'],
  ['新加坡', '+65', 'Singapore'],
  ['德国', '+49', 'Germany'],
  ['俄罗斯', '+7', 'Russia'],
  ['埃及', '+20', 'Egypt'],
  ['南非', '+27', 'South Africa'],
  ['希腊', '+30', 'Greece'],
  ['荷兰', '+31', 'Holland'],
  ['比利时', '+32', 'Belgium'],
  ['法国', '+33', 'France'],
  ['西班牙', '+34', 'Spain'],
  ['匈牙利', '+36', 'Hungary'],
  ['意大利', '+39', 'Italy'],
  ['罗马尼亚', '+40', 'Romania'],
  ['瑞士', '+41', 'Switzerland'],
  ['奥地利', '+43', 'Austria'],
  ['丹麦', '+45', 'Denmark'],
  ['瑞典', '+46', 'Rachel Canon'],
  ['挪威', '+47', 'Norway'],
  ['波兰', '+48', 'Poland'],
  ['秘鲁', '+51', 'Peru'],
  ['墨西哥', '+52', 'Mexico'],
  ['古巴', '+53', 'Cuba'],
  ['阿根廷', '+54', 'Argentina'],
  ['巴西', '+55', 'Brazil'],
  ['智利', '+56', 'Chile'],
  ['哥伦比亚', '+57', 'Columbia'],
  ['委内瑞拉', '+58', 'Venezuela'],
  ['印度尼西亚', '+62', 'Indonesia'],
  ['菲律宾', '+63', 'Philippines'],
  ['新西兰', '+64', 'New Zealand'],
  ['泰国', '+66', 'Thailand'],
  ['哈萨克斯坦', '+7', 'Kazakhstan'],
  ['韩国', '+82', 'Korea'],
  ['越南', '+84', 'Vietnam'],
  ['土耳其', '+90', 'Turkey'],
  ['印度', '+91', 'India'],
  ['巴基斯坦', '+92', 'BaStan'],
  ['阿富汗', '+93', 'Afghanistan'],
  ['斯里兰卡', '+94', 'Sri Lanka'],
  ['缅甸', '+95', 'Burma'],
  ['伊朗', '+98', 'Iran'],
  ['摩洛哥', '+212', 'Morocco'],
  ['阿尔及利亚', '+213', 'Alger'],
  ['突尼斯', '+216', 'Tunisian'],
  ['利比亚', '+218', 'Libyan'],
  ['冈比亚', '+220', 'Gambian'],
  ['塞内加尔', '+221', 'Senegalese'],
  ['马里', '+223', 'Mali'],
  ['几内亚', '+224', 'Guinean'],
  ['科特迪瓦', '+225', 'Ketediwa'],
  ['布基纳法索', '+226', 'Burkina Faso'],
  ['尼日尔', '+227', 'Niger'],
  ['多哥', '+228', 'Togo'],
  ['贝宁', '+229', 'Berlin'],
  ['毛里求斯', '+230', 'Mauritius'],
  ['利比里亚', '+231', 'Liberian'],
  ['塞拉利昂', '+232', 'Sierra Leone'],
  ['加纳', '+233', 'Ghana'],
  ['尼日利亚', '+234', 'Nigerian'],
  ['乍得', '+235', 'Chad'],
  ['中非共和国', '+236', 'Central African Republic'],
  ['喀麦隆', '+237', 'Cameroon'],
  ['圣多美和普林西比', '+239', 'Sao Tome and Principe'],
  ['加蓬', '+241', 'Gabonese'],
  ['刚果民主共和国', '+243', 'Congo democratic republic'],
  ['安哥拉', '+244', 'Angolan'],
  ['阿森松岛', '+247', 'Ascension Island'],
  ['塞舌尔', '+248', 'seychelles'],
  ['苏丹', '+249', 'Sudanese'],
  ['埃塞俄比亚', '+251', 'Ethiopian'],
  ['索马里', '+252', 'Somalian'],
  ['吉布提', '+253', 'Djibouti'],
  ['肯尼亚', '+254', 'Kenyan'],
  ['坦桑尼亚', '+255', 'Tanzanian'],
  ['乌干达', '+256', 'Ugandan'],
  ['布隆迪', '+257', 'Burundi'],
  ['莫桑比克', '+258', 'Mozambique'],
  ['赞比亚', '+260', 'Zambian'],
  ['马达加斯加', '+261', 'Madagascar'],
  ['津巴布韦', '+263', 'Zimbabwe'],
  ['纳米比亚', '+264', 'Namibian'],
  ['马拉维', '+265', 'Malawi'],
  ['莱索托', '+266', 'Lesotho'],
  ['博茨瓦纳', '+267', 'Botswana'],
  ['斯威士兰', '+268', 'Swaziland'],
  ['直布罗陀', '+350', 'Gibraltar'],
  ['葡萄牙', '+351', 'Portuguese'],
  ['卢森堡', '+352', 'Luxembourg'],
  ['爱尔兰', '+353', 'Irish'],
  ['冰岛', '+354', 'Icelandic'],
  ['阿尔巴尼亚', '+355', 'Albanian'],
  ['马耳他', '+356', 'Malta'],
  ['塞浦路斯', '+357', 'Cypriot'],
  ['芬兰', '+358', 'Finnish'],
  ['保加利亚', '+359', 'Bulgarian'],
  ['立陶宛', '+370', 'Lithuania'],
  ['拉脱维亚', '+371', 'Latvian'],
  ['爱沙尼亚', '+372', 'Estonian'],
  ['摩尔多瓦', '+373', 'Moldova'],
  ['亚美尼亚', '+374', 'Armenian'],
  ['白俄罗斯', '+375', 'Belorussia'],
  ['安道尔共和国', '+376', 'Republic of Andorra'],
  ['摩纳哥', '+377', 'Monaco'],
  ['圣马力诺', '+378', 'san marino'],
  ['乌克兰', '+380', 'Ukraine'],
  ['斯洛文尼亚', '+386', 'Slovenia'],
  ['捷克', '+420', 'Czechoslovakian'],
  ['斯洛伐克', '+421', 'Slovakian'],
  ['列支敦士登', '+423', 'Liechtenstein'],
  ['伯利兹', '+501', 'Belize'],
  ['瓜地马拉', '+502', 'Guatemala'],
  ['萨尔瓦多', '+503', 'Salvadoran'],
  ['洪都拉斯', '+504', 'Honduran'],
  ['尼加拉瓜', '+505', 'Nicaraguan'],
  ['哥斯达黎加', '+506', 'Costa Rica'],
  ['巴拿马', '+507', 'Panamanian'],
  ['海地', '+509', 'Haiti'],
  ['玻利维亚', '+591', 'Bolivian'],
  ['圭亚那', '+592', 'Guyanan'],
  ['厄瓜多尔', '+593', 'Ecuadoran'],
  ['法属圭亚那', '+594', 'French Guianan'],
  ['巴拉圭', '+595', 'Paraguay'],
  ['马提尼克', '+596', 'Martini gram'],
  ['苏里南', '+597', 'Surinam'],
  ['乌拉圭', '+598', 'Uruguayan'],
  ['文莱', '+673', 'Brunei'],
  ['巴布亚新几内亚', '+675', 'Papua New Guinean'],
  ['汤加', '+676', 'Tonga'],
  ['所罗门群岛', '+677', 'Solomon Islands'],
  ['斐济', '+679', 'Fijian'],
  ['库克群岛', '+682', 'Cook Islands'],
  ['法属波利尼西亚', '+689', 'French Polynesian'],
  ['中国澳门', '+853', 'Chinese Aomen'],
  ['柬埔寨', '+855', 'Cambodian'],
  ['老挝', '+856', 'Laos'],
  ['孟加拉国', '+880', 'Bangladesh'],
  ['马尔代夫', '+960', 'Maldives'],
  ['黎巴嫩', '+961', 'Lebanese'],
  ['约旦', '+962', 'Jordanian'],
  ['叙利亚', '+963', 'Syrian'],
  ['伊拉克', '+964', 'Iraqi'],
  ['科威特', '+965', 'Kuwaiti'],
  ['沙特阿拉伯', '+966', 'Saudi Arabian'],
  ['也门', '+967', 'Yemenese'],
  ['阿曼', '+968', 'Aman'],
  ['阿拉伯联合酋长国', '+971', 'United Arab Emirates'],
  ['以色列', '+972', 'Israeli'],
  ['巴林', '+973', 'Bahraini'],
  ['卡塔尔', '+974', 'Qataran'],
  ['蒙古', '+976', 'Mongolian'],
  ['尼泊尔', '+977', 'Nepalese'],
  ['塔吉克斯坦', '+992', 'Tajikistan'],
  ['土库曼斯坦', '+993', 'Turkmenistan'],
  ['阿塞拜疆', '+994', 'Azerbaijanian'],
  ['格鲁吉亚', '+995', 'Georgian'],
  ['吉尔吉斯斯坦', '+996', 'Kyrgyzstan'],
  ['乌兹别克斯坦', '+998', 'Uzbekistan'],
  ['巴哈马', '+1242', 'Bahamian'],
  ['巴巴多斯', '+1246', 'Barbados'],
  ['安圭拉岛', '+1264', 'Anguilla island'],
  ['安提瓜和巴布达', '+1268', 'Antigua and Barbadian'],
  ['开曼群岛', '+1345', 'cayman islands'],
  ['百慕大群岛', '+1441', 'Bermuda Islands'],
  ['格林纳达', '+1473', 'Grenada'],
  ['蒙特塞拉特岛', '+1664', 'Montserrat'],
  ['关岛', '+1671', 'Guam'],
  ['圣卢西亚', '+1758', 'Saint Lucia'],
  ['波多黎各', '+1787', 'Puerto Rico'],
  ['多明尼加共和国', '+1809', 'Dominican republic'],
  ['特立尼达和多巴哥', '+1868', 'Trinidad and Tobago'],
  ['牙买加', '+1876', 'Jamaica'],
  ['塞尔维亚共和国', '+381', 'The republic of Serbia'],
  ['毛里塔尼亚', '+222', 'Mauritania ']
]

export default selectCall



// WEBPACK FOOTER //
// ./src/util/country.js